import { getJobsQueryKey } from "@react/domains/jobs";
import {
  cursorPaginatedQueryOptions,
  offsetPaginatedQueryOptions,
  queryOptions,
} from "@react/foundation/query";

import { useAuth } from "../contexts/auth/useAuth.ts";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useQueries() {
  const { api } = useAuth();

  return {
    getBalanceQueryOptions: queryOptions({
      queryFn: api.billingAdmin.getBalance,
      queryKey: {
        group: data => ["api.billingAdmin.getBalance", data.principalId],
      },
    }),
    getJobsQueryOptions: queryOptions({
      queryFn: api.busAdmin.getJobs,
      queryKey: {
        group: getJobsQueryKey,
        variant: data => [data.order, data.cursor, data.limit],
      },
    }),
    getMediaPreviewsQueryOptions: cursorPaginatedQueryOptions({
      queryFn: api.playground.getMediaPreviews,
      queryKey: {
        group: () => ["api.playground.getMediaPreviews"],
        variant: data => [data.order, data.cursor, data.limit],
      },
    }),
    getMetricsQueryOptions: queryOptions({
      queryFn: api.admin.getAllMetrics,
      queryKey: { group: () => ["api.admin.getAllMetrics"] },
    }),
    getOAuthRequestQueryOptions: queryOptions({
      queryFn: api.oauth.getRequest,
      queryKey: { group: data => ["api.oauth.getRequest", data.id] },
    }),
    getTablesQueryOptions: offsetPaginatedQueryOptions({
      queryFn: api.admin.getTables,
      queryKey: {
        group: () => ["api.admin.getTables"],
        variant: data => [data.order],
      },
    }),
    getUsersQueryOptions: offsetPaginatedQueryOptions({
      queryFn: api.accountAdmin.getUsers,
      queryKey: {
        group: () => ["api.accountAdmin.getUsers"],
        variant: data => [data.order],
      },
    }),
  };
}
